import { render, staticRenderFns } from "./CareProtocolTabbed.vue?vue&type=template&id=6e26c178&scoped=true&"
import script from "./CareProtocolTabbed.vue?vue&type=script&lang=js&"
export * from "./CareProtocolTabbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26c178",
  null
  
)

export default component.exports